import { Perk, FileContent, FileContentFactory, Dependencies } from ".."

export interface ModifyPerk {
    activeFrom: string
    activeTo: string
    isDraft: boolean
    isActive: boolean
    isDeleted: boolean
    names: {
        [key: string]: string
    }
    descriptions: {
        [key: string]: string
    }
    image: FileContent
    contact: {
        email: string
        phoneNumber: string
    }
    link: string
    categoryIds: string[]
    locationIds: string[]
    dependencies: Dependencies | null
}

export class ModifyPerkFactory {
    static create(): ModifyPerk {
        return {
            activeFrom: "",
            activeTo: "",
            isDraft: false,
            isActive: false,
            isDeleted: false,
            names: {},
            descriptions: {},
            image: FileContentFactory.create(),
            contact: { email: "", phoneNumber: "" },
            link: "",
            categoryIds: [],
            locationIds: [],
            dependencies: null,
        }
    }

    static from(perk: Perk): ModifyPerk {
        const modifyPerk: ModifyPerk = JSON.parse(
            JSON.stringify({
                activeFrom: perk.activeFrom ?? "",
                activeTo: perk.activeTo ?? "",
                isDraft: perk.isDraft,
                isActive: perk.isActive,
                isDeleted: perk.isDeleted,
                names: perk.names,
                descriptions: perk.descriptions,
                image: FileContentFactory.fromUrl(perk.imageUrl ?? ""),
                contact: perk.contact ?? { email: "", phoneNumber: "" },
                link: perk.link ?? "",
                categoryIds: perk.categoryIds ?? [],
                locationIds: perk.locationIds ?? [],
                dependencies: perk.dependencies ?? null,
            })
        )
        return modifyPerk
    }
}
